import React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {bindActionCreators} from 'redux';

import { getImageUrl } from '../../api/iposApi';
import {orderTotal} from '../../redux/selectors/order';
import {isMobileAndTablet} from '../../helpers/common';
import OrderInfoItem from '../components/OrderInfoItem';
import FormattedPrice from '../../components/FormattedPrice';
import UtensilsInfoItem from '../components/UtensilsInfoItem';
import DeliveryInfoItem from '../components/DeliveryInfoItem';

import './OrderInfoPage.scss';

const OrderInfoPage = ({t, orderItems, totalAmount, orderInfo, clientInfo, branchInfo, currentLanguageId}) => {
  const isMobile = isMobileAndTablet();

  if (orderItems.length === 0) {
    return (
      <div className={ 'order_info_page' }>
        <div className="container" />
      </div>
    );
  }

  return (
    <div className={ 'order_info_page' }>
      <img src={getImageUrl(branchInfo.LogoImageName)} className="img-logo" alt="iPos Web Delivery"/>

      <div className="container">
        <div className={ 'row' }>
          <div className="col-md-12">
            <div className={ 'order-header' }>
              <div className={ 'order-confirmed' }>{t('order_info.order_confirmed')}</div>

              <div className={ 'order-greetings' }>
                {orderInfo.is_take_away_order === 1 && (
                  t('order_info.greetings_ta', {clientName: clientInfo.client_name})
                )}

                {orderInfo.is_take_away_order !== 1 && (
                  t('order_info.greetings_delivery', {clientName: clientInfo.client_name})
                )}

              </div>

            </div>
          </div>
        </div>

        <div className={ 'row' }>
          <div className="col-md-12 order-info">
            <div className={ 'order-id' }>{t('order_info.order_id')} {orderInfo.order_id}</div>
            <div className={ 'details' }>
              {clientInfo.client_address && (
                <div className={ 'detail-row' }>
                  <div className={ 'detail-label' }>{t('order_info.delivery_address')}</div>
                  <div className={ 'detail-value' }>{clientInfo.client_address}</div>
                </div>
              )}

              <div className={ 'detail-row' }>
                <div className={ 'detail-label' }>{t('order_info.payment_type')}</div>
                <div className={ 'detail-value' }>{orderInfo.paymentsName}</div>
              </div>
              {orderInfo.is_take_away_order !== 1 && (
                <div className={ 'detail-row' }>
                  <div className={ 'detail-label' }>{t('order_info.delivery_time')}</div>
                  <div className={ 'detail-value' }>{branchInfo.DeliveryTime} {t('order_info.min')}</div>
                </div>
              )}
            </div>

            {/*<div className={'details'}>*/}
            {/*  <div className={'title'}>Order Details</div>*/}
            {/*  <div className={'detail-row'}>*/}
            {/*    <div className={'detail-label'}>Date</div>*/}
            {/*    <div className={'detail-value'}>03/03/2021</div>*/}
            {/*  </div>*/}

            {/*  <div className={'detail-row'}>*/}
            {/*    <div className={'detail-label'}>Payment Type</div>*/}
            {/*    <div className={'detail-value'}>Credit Card *4441</div>*/}
            {/*  </div>*/}
            {/*</div>*/}

          </div>
        </div>

        <div className={ 'row' }>
          <div className="col-md-12 order-summary">
            <div className={ 'title' }>{t('order_info.order_summary')}</div>
            <div className={ 'order-items-list' }>
              {
                orderItems.length > 0 && orderItems.map((item) => {
                    switch (item.menuItemType) {
                      case 'DISHES_ITEM': {
                        return <UtensilsInfoItem item={ item } />;
                      }
                      case 'DELIVERY_ITEM': {
                        return <DeliveryInfoItem item={ item } />;
                      }
                      default: {
                        return <OrderInfoItem item={ item } currentLanguageId={ currentLanguageId } branchInfo = {branchInfo}/>;
                      }
                    }
                  }
                )
              }
              <div className={ 'order-item-info totals' }>
                <div className={ 'info-block' }>
                  <div className={ 'parent-item-info' }>
                    <div className={ 'item-info-block' }>
                      <div className={ 'item-name' }>{t('order_info.total')}</div>
                    </div>

                    <div className={ 'item-quantity-info-block' }>
                      <div className={ 'item-quantity-info' }>&nbsp;</div>
                    </div>

                    <div className={ 'item-price-block' }>
                      <div className={ 'item-price' }>
                        <b><FormattedPrice price={ totalAmount } /></b>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={ 'row' }>
          <div className="col-md-12 order-footer">
            {/*<div className={ 'greetings' }>{t('order_info.thank_you_ipos')}</div>*/}

            <div className={ 'assistance' }>
              {t('order_info.need_assistance')}
            </div>

            <div className={ 'assistance-info' }>
              {t('order_info.assistance_notes')}
            </div>

            <div className={ 'copyright' }>
              powered by <b> iPOS</b>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const {
    branchInfo,
    orderItems,
    orderInfo,
    clientInfo,
    currentLanguageId
  } = state;

  return {
    branchInfo,
    totalAmount: orderTotal(state),
    orderItems,
    orderInfo,
    clientInfo,
    currentLanguageId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {},
    dispatch,
  );
export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(OrderInfoPage));
